import React from 'react'
import { Tooltip, Chip, } from '@mui/material';


export const CommunicationFailsTooltipChips = ({ contractFails, handleActivate, deviceCount, colorFail120, colorFail96, colorFail72, colorFail48, colorFail24 }) => {
  return (
    <>
      <Tooltip title={`${colorFail120.percentage}%`}>
        <Chip label={`${colorFail120.value}`} size='small' style={{ backgroundColor: colorFail120.color }} onClick={() => { handleActivate(contractFails.fails120) }} />
      </Tooltip>
      <Tooltip title={`${colorFail96.percentage}%`}>
        <Chip label={`${colorFail96.value}`} size='small' style={{ backgroundColor: colorFail96.color }} onClick={() => handleActivate(contractFails.fails96)} />
      </Tooltip>
      <Tooltip title={`${colorFail72.percentage}%`}>
        <Chip label={`${colorFail72.value}`} size='small' style={{ backgroundColor: colorFail72.color }} onClick={() => handleActivate(contractFails.fails72)} />
      </Tooltip>
      <Tooltip title={`${colorFail48.percentage}%`}>
        <Chip label={`${colorFail48.value}`} size='small' style={{ backgroundColor: colorFail48.color }} onClick={() => handleActivate(contractFails.fails48)} />
      </Tooltip>
      <Tooltip title={`${colorFail24.percentage}%`}>
        <Chip label={`${colorFail24.value}`} size='small' style={{ backgroundColor: colorFail24.color }} onClick={() => handleActivate(contractFails.fails24)} />
      </Tooltip>
      <span style={{ fontWeight: 'bold', marginLeft: '10px' }}>
        {deviceCount}
      </span>
    </>
  )
}
